import React, { useEffect, useState } from 'react';
import { 
  Box,
  Button,
  Flex,
  Text,
  useToast,
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Link
} from '@chakra-ui/react';
import { cqAPI, Auth } from "../../lib/Auth";
import moment from 'moment'; // Assuming you use moment for date formatting
import SignDocument from '../SignDocument/SignDocument'; // Import the SignDocument component

function Form() {
  const [forms, setForms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isSignModalOpen, setIsSignModalOpen] = useState(false);
  const [selectedSignatureRequestId, setSelectedSignatureRequestId] = useState(null);
  const toast = useToast();
  
  const fetchForms = async () => {
    try {
      const response = await cqAPI.get('/pp/forms');
      setForms(response.data);
    } catch (error) {
      console.error('Error fetching forms numbers:', error);
    }
  };

  useEffect(() => {
    fetchForms();
  }, []);

  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);

  const handleSign = (signatureRequestId) => {
    setSelectedSignatureRequestId(signatureRequestId);
    setIsSignModalOpen(true);
  };

  const handleSignModalClose = () => {
    setIsSignModalOpen(false);
    setSelectedSignatureRequestId(null);
  };

  const handleSignatureSuccess = () => {
    setIsSignModalOpen(false);
    setSelectedSignatureRequestId(null);
    // Optionally, refresh forms or show a success toast
    fetchForms();
  };
  
  const downloadFile = async (attachmentUrl, fileName) => {
    try {
      const downloadUrl = await cqAPI.downloadFile(attachmentUrl);
      if (!downloadUrl) {
        console.error("File unavailable for download:", attachmentUrl);
        return;
      }

      // Create a temporary link element and trigger the download
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", fileName); // Set the file name for the download
      document.body.appendChild(link);
      link.click();

      // Clean up by revoking the blob URL and removing the temporary link
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download file:", error);
    }
  };
  
  const cancelForm = async (signature_request_id)=>{
    const response = await cqAPI.del(`/forms?request_id=${signature_request_id}`);
    if (response.type === 'ok') {
      fetchForms();
    } else {
      toast({ title: "Error", description: response.msg, status: "error" });
    }
  }

  return (
    <Box p={4} overflowY="auto" maxHeight="100vh" width="100%" position="relative">

      {/* Modal for signing a document */}
      <Modal isOpen={isSignModalOpen} onClose={handleSignModalClose} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <SignDocument signatureRequestId={selectedSignatureRequestId} onSuccess={handleSignatureSuccess} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Box p={4} overflowY="auto" maxHeight="100vh" width="100%" position="relative">
        <SimpleGrid columns={{ base: 1, md: 3, lg: 1 }} >
          {Array.isArray(forms) && forms.map(({ metadata, business, created, title, _id, signature_request_id, is_complete }) => (
            <Box key={_id} borderWidth="1px" borderRadius="lg" mb={4} width="100%" className="actionableItem">
              <Flex direction="column" p={4} justify="space-between" height="100%">
                {/* Flex container to align texts to the left and the button to the far right */}
                <Flex justify="space-between" align="right" textAlign="left">
                  {/* Flex item for the texts */}
                  <Box>
                    <Text fontSize="sm"> Title: <b>{title}</b></Text>
                    <Text fontSize="sm"> Created on: <b>{moment(created).format('MMMM Do YYYY, h:mm:ss a')}</b></Text>
                  </Box>
                  {/* Button aligned to the far right */}
                  {is_complete ? (
                    <Button 
                      onClick={(e) => {
                        e.preventDefault();
                        downloadFile(`/forms/download?request_id=${signature_request_id}`, `${title}.pdf`);
                      }}
                    >
                      Download
                    </Button>
                  ) : (
                    <Flex direction="column" alignItems="center">
                      <Button onClick={() => handleSign(signature_request_id)}>
                        Sign
                      </Button>
                      {!Auth.user.isPatient && (
                        <Link mt={2} color="red.500" textAlign="center" onClick={()=>cancelForm(signature_request_id)}>Cancel</Link>
                      )}
                    </Flex>
                  )}
                </Flex>
              </Flex>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
}

export default Form;
